
/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

//redux
import { connect } from 'react-redux'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Badge from 'components/Badge/Badge.jsx';
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";

import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";
  
//icons
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import Person from "@material-ui/icons/Person";
import History from "@material-ui/icons/History";
import Lock from "@material-ui/icons/Lock";

class HeaderLinks extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      cart: props.cart,
      query:""
    }
  }

  componentWillReceiveProps(nextProps){
    /*
    if(nextProps.searchQuery) {
      this.setState({query: nextProps.searchQuery}, () => {
      
      });
    }*/
    
    if(nextProps.cart) {
      this.setState({cart: nextProps.cart}, () => {
        
      });
    }
  }

  easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  smoothScroll = (e, target) => {
    if (window.location.pathname === "/sections") {
      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      );
      if (isMobile) {
        // if we are on mobile device the scroll into view will be managed by the browser
      } else {
        e.preventDefault();
        var targetScroll = document.getElementById(target);
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
      }
    }
  };
  scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  //var onClickSections = {};

  supportMaterialLink = () => {
    if (this.props.user.authenticated) {
      return "/support-material";
    } else {
      return "/login"
    }
  }

  showSupportMaterial = () => {
    if(this.props.user.authenticated 
      && this.props.user.userType !== 'student'
      && this.props.user.schoolID !== 'ExYodx7WZrChO0N1JDbC') { // keiki high
      return 'block';
    } else {
      return 'none';
    }

  }

  showLessons = () => {
    if(this.props.user.authenticated) {
      return 'block';
    } else {
      return 'none';
    }
  }

  showShopping() {
    if(this.props.user.authenticated && this.props.user.userType === 'admin') {//&& this.props.user.userType !== 'student') {
      return "block";
    } else {
      return "none";
    }
  }

  showCart() {
    if (this.props.user.authenticated && this.state.cart.length > 0) {
      return "block";
    } else {
      return "none"
    }
  }

  showLogin() {
    if (!this.props.user.authenticated) {
      return "block";
    } else {
      return "none"
    }
  }

  showMenu() {
    if (this.props.user.authenticated) {
      return "block";
    } else {
      return "none"
    }
  }

  getSchool() {
    if(this.props.user.school) {
      return this.props.user.school.Name;
    } else {
      return "";
    }
  }

  //const { classes, dropdownHoverColor } = props;
  render() {
    const { classes, ...rest } = this.props;

    
    if(this.props.logo) {
      return <img src={this.props.logo} style={{maxHeight:"69px",position:"absolute", right:"10px", padding:"6px"}} />
    }
    else return (
      <List className={classes.list + " " + classes.mlAuto}>
         <ListItem className={classes.listItem}>
            <Link to="/insights" className={classes.navLink} style={{display:this.showLessons() }}>
              Insights
            </Link>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Link to={this.supportMaterialLink()} className={classes.navLink} style={{display:this.showSupportMaterial() }}>
              Support Material
            </Link>
          </ListItem>
          <ListItem className={classes.listItem} style={{display:this.showShopping()}}>
            <Link to={"/ecommerce-page"} className={classes.navLink} >
              Products
            </Link>
          </ListItem>
          <ListItem className={classes.listItem} style={{display:this.showCart()}}>
            <Link to="/cart" style={{color:"white", fontWeight:400}}>
              <GridContainer>
                <GridItem xs={4}><Badge color="success">{this.state.cart.length}</Badge></GridItem>
                <GridItem xs={5}><ShoppingCart style={{fontSize:"20px", position:"relative", top:"4px"}} /></GridItem>
              </GridContainer>
            </Link>
          </ListItem>
          <ListItem className={classes.listItem} style={{display:this.showLogin()}}>
            <Link to='/login' className={classes.navLink} >
              Login 
            </Link>
          </ListItem>
          <ListItem className={classes.listItem} style={{display:this.showMenu()}}>
            <CustomDropdown
              noLiPadding
              navDropdown
              hoverColor="success"
              buttonText={this.getSchool()}
              buttonProps={{
                className: classes.navLink,
                color: "transparent"
              }}
              buttonIcon={Person}
              dropdownList={[
                <Link to="/orders" className={classes.dropdownLink} style={{display:this.showShopping()}}>
                  <History className={classes.dropdownIcons} /> Quotes / Orders
                </Link>,
                <Link to='/logout' className={classes.dropdownLink}>
                  <Lock className={classes.dropdownIcons} /> Logout
                </Link>
              ]}
            />
        </ListItem>
      </List>
    );
  }
}

HeaderLinks.defaultProps = {
  hoverColor: "primary"
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ])
};


const mapStateToProps = state => {
  return state;
}

HeaderLinks = connect(mapStateToProps)(HeaderLinks);
export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx